import { useFormatCurrency } from "@dgs/core";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { PaymentTransactionItem, ShopSummaryTaxWithDisclaimerIndex } from "../../../shared/types";
import { Bold } from "../../../shared/ui/Bold";
import { Span } from "./ShopSummaryComponents";

interface PriceProps {
	item: PaymentTransactionItem;
	taxes: ShopSummaryTaxWithDisclaimerIndex[];
}

const StyledGrid = styled.div`
	display: grid;
	grid-template-columns: max-content max-content;
	gap: ${({ theme }) => theme.spacing(1)};
	column-gap: ${({ theme }) => theme.spacing(2)};
	justify-content: end;
	justify-items: end;
	align-items: end;
`;

export function PaymentTransactionItemPrice({ item, taxes }: PriceProps) {
	const { t } = useTranslation();
	const formatCurrency = useFormatCurrency(item.currencyType);

	return (
		<StyledGrid>
			<Bold>
				<Trans
					i18nKey="Item amount<sup>{{ taxDisclaimer }}</sup>:"
					values={{ taxDisclaimer: taxes.find((t) => t.percent === item.taxRate)?.index }}
					components={{ sup: <sup /> }}
				/>
			</Bold>
			<Bold>{formatCurrency(item.totalPrice)}</Bold>
			{item.refundTotalPrice !== null && (
				<>
					<span>{t("Refund amount:")}</span>
					<span>{formatCurrency(item.refundTotalPrice)}</span>
					{item.hasCancellationConfig && <Span>{t("Cancellation fee applied")}</Span>}
				</>
			)}
		</StyledGrid>
	);
}
